import React, { useEffect, useState } from "react";
import { db } from "../firebase"; // Import Firestore
import { doc, getDoc, setDoc } from "firebase/firestore"; // Firestore functions
import Header from "./header";

export default function Schedule() {
  const [schedule, setSchedule] = useState({});
  const [editedSchedule, setEditedSchedule] = useState({});
  const [isEdited, setIsEdited] = useState(false);

  useEffect(() => {
    fetchSchedule();
  }, []);

  // Fetch schedule data from Firestore
  const fetchSchedule = async () => {
    const docRef = doc(db, "schedule", "timetable");
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      const data = docSnap.data();
      setSchedule(data);
      setEditedSchedule(data);
    } else {
      console.error("No such document!");
    }
  };

  // Handle input change
  const handleEdit = (key, value) => {
    setEditedSchedule((prev) => ({
      ...prev,
      [key]: value,
    }));
    setIsEdited(true);
  };

  // Save updated schedule to Firestore
  const handleSave = async () => {
    const docRef = doc(db, "schedule", "timetable");
    await setDoc(docRef, editedSchedule);
    setSchedule(editedSchedule);
    setIsEdited(false);
  };

  // ** Order: Monday to Sunday, then text1 and text2 **
  const orderedKeys = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
    "text1",
    "text2",
  ];

  return (
    <div>
      <Header />
      <div className="schedule-container">
        <h2>Schedule Page</h2>
        <p>Manage your schedules here.</p>

        {/* Editable Table */}
        <table className="schedule-table">
          <thead>
            <tr>
              <th>Day</th>
              <th>Schedule</th>
            </tr>
          </thead>
          <tbody>
            {orderedKeys.map((day) =>
              schedule[day] !== undefined ? ( // Show only existing fields
                <tr key={day}>
                  <td>{day}</td>
                  <td>
                    <input
                      type="text"
                      value={editedSchedule[day] || ""}
                      onChange={(e) => handleEdit(day, e.target.value)}
                    />
                  </td>
                </tr>
              ) : null
            )}
          </tbody>
        </table>

        {/* Save Button */}
        {isEdited && (
          <button className="save-btn" onClick={handleSave}>
            Save Changes
          </button>
        )}
      </div>
    </div>
  );
}
